import * as _ from 'lodash';
import {IMPModule} from "./marketing-page.models";
import {ICartImage} from "../cart/catalog/catalog-models";

export class MarketingPageUtil {

    static getTranslationRoot(pageUrl: string, moduleName: string) {
        return 'cart.mp.'+pageUrl+'.'+moduleName;
    }

    static getAlignmentClass(value: string): string {
        switch(value) {
            case "RIGHT":
                return "right-aligned";
            case "CENTER":
                return "center-aligned";
            default:
                return "left-aligned";
        }
    }

    static getTextStyleClass(value: string): string {
        switch(value) {
            case "LIGHT":
                return "font-light";
            default:
                return "font-dark";
        }
    }

    static getButtonTypeClass(value: string): string {
        switch(value) {
            case "SECONDARY":
                return "button-secondary";
            case "GREY_SHOP":
                return "button-grey";
            default:
                return "button-primary";
        }
    }

    static getImageAlignmentCLass(value: string) {
        switch(value) {
            case "RIGHT":
                return "image-align-right";
            default:
                return "image-align-left";
        }
    }

    static getBackgroundColor(value: string) {
        if (_.isEmpty(value) || value.length < 6) {
            value = "#ffffff";
        } else {
            value = '#' + value;
        }
        return value;
    }

    static getCartImagesFromModule(module: IMPModule): ICartImage[] {
        const result: ICartImage[] = [];
        if (module.countryDetails?.length > 0 && module.countryDetails[0]?.images) {
            module.countryDetails[0].images.forEach((moduleImage) => {
                result.push(moduleImage.cartImage);
            });
        }
        return result;
    }
}
